'use strict';

const libPictView = require('pict-view');
const html = String.raw;

/**
 * PhysicalAssetDashboard — the thin standalone screen (#/AssetDashboard[/:View]) that hosts the physical-asset
 * dashboard: Map · Browse · Overview over the inventory + its backfilled metadata. The provider paints into
 * #PAD-Host. Full browser width via Dashboard Mode. See [[PhysicalAssetDashboard-Provider.js]].
 */
class PhysicalAssetDashboardView extends libPictView
{
	get provider() { return this.pict.providers['PhysicalAssetDashboard']; }

	onAfterRender(pRenderable)
	{
		this.pict.CSSMap.injectCSS();
		const tmpProvider = this.provider;
		if (tmpProvider) { tmpProvider._mount = '#PAD-Host'; tmpProvider.loadAsync(); }
		return super.onAfterRender(pRenderable);
	}
}

module.exports = PhysicalAssetDashboardView;

module.exports.default_configuration =
{
	ViewIdentifier: 'PhysicalAssetDashboard',
	DefaultRenderable: 'PhysicalAssetDashboardWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	DashboardMode: true,

	CSS: /*css*/`
		.pad-page { padding: 1.25rem 2rem 2rem; }
		.pad-page-h { font-size: 1.4rem; font-weight: 800; color: var(--theme-color-text-primary,#1f2733); margin: 0 0 0.15rem; display:flex; align-items:center; gap:0.6rem; }
		.pad-page-h i { color: var(--theme-color-brand-primary,#2e7d74); }
		.pad-page-sub { font-size: 0.9rem; color: var(--theme-color-text-muted,#6b7686); margin: 0 0 1rem; }
	`,

	Templates:
	[
		{
			Hash: 'PhysicalAssetDashboard-Template',
			Template: html`
				<section class="section pad-page">
					<h1 id="PAD-Heading" class="pad-page-h"><i class="fas fa-map-location-dot"></i> Asset Dashboard</h1>
					<p id="PAD-Subheading" class="pad-page-sub">Map, browse, and analyze the physical-asset inventory.</p>
					<div id="PAD-Host"></div>
				</section>`,
		},
	],

	Renderables:
	[
		{
			RenderableHash: 'PhysicalAssetDashboardWrap',
			TemplateHash: 'PhysicalAssetDashboard-Template',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
